document.addEventListener('DOMContentLoaded', function () {
  var supportRoot = document.querySelector('[data-pm-support-chat]');

  function getNativeChatState() {
    var shopifyChat = document.querySelector('shopify-chat');
    var shellRoot = shopifyChat && shopifyChat.shadowRoot;
    var runtime = shellRoot && shellRoot.querySelector('shopify-agent-runtime');
    var shadowRoot = (runtime && runtime.shadowRoot) || shellRoot;
    var activator = shadowRoot && shadowRoot.querySelector('button[part="activator"], button.activator');
    return {
      shopifyChat: shopifyChat,
      shellRoot: shellRoot,
      runtime: runtime,
      shadowRoot: shadowRoot,
      activator: activator
    };
  }

  function suppressNativeChatActivator() {
    var state = getNativeChatState();
    var activator = state.activator;
    if (!activator) return false;

    var hiddenStyles = {
      position: 'fixed',
      left: '-9999px',
      top: '0',
      width: '1px',
      height: '1px',
      minWidth: '1px',
      minHeight: '1px',
      maxWidth: '1px',
      maxHeight: '1px',
      margin: '0',
      padding: '0',
      border: '0',
      opacity: '0',
      overflow: 'hidden',
      pointerEvents: 'none',
      clipPath: 'inset(50%)'
    };

    Object.keys(hiddenStyles).forEach(function (property) {
      activator.style.setProperty(property.replace(/[A-Z]/g, function (character) {
        return '-' + character.toLowerCase();
      }), hiddenStyles[property], 'important');
    });
    if (activator.getAttribute('aria-hidden') !== 'true') activator.setAttribute('aria-hidden', 'true');
    if (activator.tabIndex !== -1) activator.tabIndex = -1;
    return true;
  }

  function chatIsOpen(state) {
    if (!state.shadowRoot) return false;
    if (state.activator && state.activator.getAttribute('aria-expanded') === 'true') return true;
    var dialog = state.shadowRoot.querySelector('[part="dialog"], [role="dialog"]');
    return Boolean(dialog && !dialog.hasAttribute('inert') && dialog.getClientRects().length > 0);
  }

  suppressNativeChatActivator();
  window.setInterval(suppressNativeChatActivator, 500);

  if (!supportRoot) return;

  supportRoot.querySelectorAll('[data-pm-open-chat]').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      trigger.removeAttribute('data-pm-open-chat');
      trigger.setAttribute('href', '/pages/contact');
      window.location.assign('/pages/contact');
    });
  });
});
